export const BILLING_MODELS = {
  PLG: 'PLG',
  PAY_AS_YOU_GO: 'pay_as_you_go',
  PREPURCHASE: 'prepurchase',
  POV: 'POV',
}

export const CREDIT_EXHAUSTION_THRESHOLDS = {
  WARNING: 0.8,
  EXHAUSTED: 1,
}

export const CREDIT_NOTIFICATION_TYPES = {
  PLG_EXHAUSTED: 'plg_exhausted',
  APPROACHING_LIMIT: 'approaching_limit',
  CREDIT_LIMIT_REACHED: 'credit_limit_reached',
  CREDITS_RESTORED: 'credits_restored',
}

export const CREDIT_REQUEST_EVENTS = {
  REQUEST_MORE: 'request_more_credits',
  ADD_CREDITS: 'add_credits',
  GET_QUOTE: 'get_quote',
}

// Dedicated KB article per the Usage-dashboard PRD (Confluence 1966899240).
export const HOW_CREDITS_WORK_URL =
  'https://support.ironscales.com/hc/en-us/articles/25596138695452-Managing-your-AI-Credits'

export const CREDIT_NOTIFICATIONS_COPY = {
  [CREDIT_NOTIFICATION_TYPES.PLG_EXHAUSTED]: {
    title: 'Your team is out of AI credits.',
    // Body stays this sentence. The reset date is a separate row (selectNextResetLabel).
    subtext: () => "You've used all preview credits for this month.",
    cta: 'Add more credits',
  },
  [CREDIT_NOTIFICATION_TYPES.APPROACHING_LIMIT]: {
    payAsYouGo: {
      title: 'Approaching your monthly credit limit.',
      subtext: ({ resetDateLabel }) =>
        `You've used 80% of your monthly limit.${
          resetDateLabel ? ` Credits reset on ${resetDateLabel}.` : ''
        }`,
      cta: 'Add more credits',
    },
    prepurchase: {
      title: 'Approaching your credit limit.',
      subtext: ({ expirationDateLabel }) =>
        `You've used 80% of your purchased credits.${
          expirationDateLabel ? ` Credits expire on ${expirationDateLabel}.` : ''
        }`,
      cta: 'Add more credits',
    },
  },
  [CREDIT_NOTIFICATION_TYPES.CREDIT_LIMIT_REACHED]: {
    payAsYouGo: {
      title: 'Your team has reached its monthly credit limit.',
      subtext: ({ resetDateLabel }) =>
        `AI features are paused. Increase your limit or wait for credits to reset on ${
          resetDateLabel || 'the next reset date'
        }.`,
      cta: 'Add more credits',
    },
    prepurchase: {
      title: 'Your team has used all of its purchased credits.',
      subtext: () =>
        'Your team is in a grace period. Contact your account manager to purchase more credits.',
      cta: 'Add more credits',
    },
  },
  [CREDIT_NOTIFICATION_TYPES.CREDITS_RESTORED]: {
    title: 'AI Credits are available!',
    subtext: () => 'All AI based features are now ready to use',
  },
}

export const CREDIT_REQUEST_POPUP_COPY = {
  PLG: {
    title: 'Your team is out of AI credits',
    // IC-49735 — toast copy aligned to Figma 4584:149296 ("free credits").
    subtext: ({ userName, otherCount }) => {
      if (!userName) return "You've used all free credits this month."
      const requesterText =
        otherCount > 0
          ? `${userName} and ${otherCount} others are requesting additional credits`
          : `${userName} is requesting additional credits`
      return `You've used all free credits this month. ${requesterText}.`
    },
  },
  PAID: {
    title: 'Your team has reached its credit limit',
    subtext: ({ userName, otherCount }) => {
      if (!userName) return 'Your organization has used all available credits.'
      const requesterText =
        otherCount > 0
          ? `${userName} and ${otherCount} others are requesting additional credits`
          : `${userName} is requesting additional credits`
      return `Your organization has used all available credits. ${requesterText}.`
    },
  },
}

// body is an array of lines — the mock renders the subtext on two lines.
// The "Your admin can add more" line only makes sense when the viewer ISN'T the
// admin — admins get a single-line subtext (IC-49435 QA: must not appear for admins).
export const CREDIT_BLOCKED_STATE_COPY = {
  PLG: {
    // PLG Experience §2.1 — one blocked screen; only the CTA differs by role.
    user: {
      title: 'Free preview limit reached',
      body: ["You've used your free credits for this month.", 'Your admin can add more.'],
    },
    admin: {
      title: 'Free preview limit reached',
      body: ["You've used your free credits for this month."],
    },
  },
  PAID: {
    // Purchase Flow §3.1 — one blocked screen; only the CTA differs by role.
    user: {
      title: "You're out of credits",
      body: ['Your organization has reached its credit limit.', 'Your admin can add more.'],
    },
    admin: {
      title: "You're out of credits",
      body: ['Your organization has reached its credit limit.'],
    },
  },
}
